import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AClaveRequest } from '../../types/aclave';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ArrobaClaveService {
    /*********************************************************
     * MÉTODOS USADOS PARA LOGIN/LOGOUT CONTRA Cl@ve
     *********************************************************/

    private endpoint = '';

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {
        this.endpoint = this.baseUrl + 'api/clave/aclave';
    }

    doGetLoginRequest(): Observable<AClaveRequest> {
        return this.http.get<AClaveRequest>(this.endpoint);
    }

    doLogoutClave(XmlSignedId: string): Observable<any> {
        return this.http.post<any>(this.endpoint + '/logout/', null);
    }

    doInvokeOptions(): Observable<Object> {
        const urlOptions = this.endpoint + '/options/';
        return this.http.options(urlOptions);
    }
}
